import { changePlayerToGameStatus, getTrainingGamePlayers } from 'services/training-games-players'
import { TrainingGamesPlayersTable } from '../../../components/training-games-players-table'
import { TrainingGamePlayer } from 'types/game-player'
import { useCallback, useEffect, useState } from 'react'
import styles from './index.module.scss'
import { useParams } from 'react-router-dom'
import { getTrainingGameById } from 'services/training-games'
import { TrainingGame } from 'types/games'

export const Game = () => {
    const { gameId } = useParams()
    const [dataIsFetching, setDataIsFetching] = useState<boolean>(false)
    const [players, setPlayers] = useState<TrainingGamePlayer[]>([])
    const [game, setGame] = useState<TrainingGame | null>()

    useEffect(() => {
        if (gameId) {
            getTrainingGameById(Number(gameId)).then(setGame)
        }
    }, [gameId])

    const getAllData = useCallback(() => {
        setDataIsFetching(true)

        const getAll = async function (gameId: number) {
            return await getTrainingGamePlayers(gameId)
        }

        if (gameId) {
            getAll(Number(gameId))
                .then(data => {
                    setPlayers(data)
                })
                .finally(() => {
                    setDataIsFetching(false)
                })
        }
    }, [gameId])

    useEffect(() => {
        getAllData()
    }, [getAllData, gameId])

    const changeStatus = useCallback(
        (telegramId: number, gameId: number, reserve: number) => {
            changePlayerToGameStatus(telegramId, gameId, reserve).then(getAllData)
        },
        [getAllData]
    )

    const handleMoveToMain = useCallback(
        (telegramId: number, gameId: number) => {
            changeStatus(telegramId, gameId, 0)
        },
        [changeStatus]
    )

    const handleMoveToReserve = useCallback(
        (telegramId: number, gameId: number) => {
            changeStatus(telegramId, gameId, 1)
        },
        [changeStatus]
    )

    return (
        <div>
            {game && (
                <div className={styles.title}>
                    Game "{game.field.name}" {game.date} {game.timeStart}-{game.timeEnd}
                </div>
            )}

            <TrainingGamesPlayersTable
                data={players}
                onDelete={() => {}}
                loading={dataIsFetching}
                onMoveToMain={handleMoveToMain}
                onMoveToReserve={handleMoveToReserve}
            />
        </div>
    )
}
